<div style="position: relative" class="full-height">
  <ng-template #content>
    <ng-content></ng-content>
  </ng-template>

  <div
    *ngIf="loading && showContentWhileLoading"
    class="loading-overlay full-height"
    fxLayout
    fxLayoutAlign="center center"
  >
    <mat-spinner></mat-spinner>
  </div>

  <div
    *ngIf="loading && !showContentWhileLoading; else content"
    class="full-height"
    fxLayout
    fxLayoutAlign="center center"
  >
    <mat-spinner></mat-spinner>
  </div>
</div>
